export const  setImageNoAutooplay = (video, setVisibleImage) =>{
    if(video) {
        var promise = video.play();
        if (promise !== undefined) {
            promise.then(function() {
                setVisibleImage(false);
            }).catch(function() {
                setVisibleImage(true);
            });
        }
    }
}